import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { IManifestInfo } from '../../types/manifestInfo';
import { DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY } from '../../../node/services/fetchDesktopFilters';

export const DesktopFiltersContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const manifestInfo = config.get<IManifestInfo | null>(DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY);

  if (!manifestInfo) {
    return null;
  }

  return <Microfrontend {...manifestInfo} />;
};
